import { render } from "./BorderMultiSelect.vue?vue&type=template&id=dd797d62&scoped=true"
import script from "./BorderMultiSelect.vue?vue&type=script&lang=js"
export * from "./BorderMultiSelect.vue?vue&type=script&lang=js"

import "./BorderMultiSelect.vue?vue&type=style&index=0&id=dd797d62&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dd797d62"

export default script